const menuBtn = document.querySelector('.menu-btn');
const hamburger = document.querySelector('.menu-btn__burger');
const navbar = document.querySelector('.nav');
const menuNav = document.querySelector('.menu-nav');
const navItems = document.querySelectorAll('.menu-nav__item');
let showMenu = false;
const toggleMenu = () => {
  if (!showMenu) {
    hamburger.classList.add('open');
    navbar.classList.add('open');
    menuNav.classList.add('open');
    navItems.forEach((item) => item.classList.add('open'));
    showMenu = true;
  } else {
    hamburger.classList.remove('open');
    navbar.classList.remove('open');
    menuNav.classList.remove('open');
    navItems.forEach((item) => item.classList.remove('open'));
    showMenu = false;
  }
  console.log(showMenu);
};
menuBtn.addEventListener('click', toggleMenu);
